import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxReport from '../util/remote/ajaxReport';

const initialState = { 
    accountId: null,
    accountInfo: null,
    statement: null,
    metaData: null,
    currentPage: 1,
    dateRange: { opening_date: "", closing_date: "" },
    mounted: false,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const AccountReportContext = createContext();

export const AccountReportProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  /**
   * Only call this if the getTransactions has already been called on mount by the AccountStatementPage
   */
  useEffect(()=>{
    if(state.mounted){
      getStatement();
    }
  }, [state.currentPage])

  //Reset mechanism for account
  useEffect(()=>{
    if (state.accountInfo?.account_id) {
      dispatch({ type: "statement", payload: null });
      dispatch({ type: "metaData", payload: null });
      setCurrentPage(1);
    }
  }, [state.accountInfo]);


  const getStatement = async (refresh = false, period = null) => {
    dispatch({ type: "mounted", payload: true });

    if (refresh) {
        dispatch({ type: "statement", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
    }

    const server_response = await ajaxReport.fetchAccountStatement({
        account_id: state.accountInfo?.account_id, // Optional chaining for safety
        page: refresh ? 1 : state.currentPage,
        opening_balance: refresh ? 0 : state.statement?.summary?.running_opening_balance || 0,
        opening_date: period?.opening_date || state.dateRange?.opening_date,
        closing_date: period?.closing_date || state.dateRange?.closing_date
    });

    if (server_response.status === "OK") {
        const newTransactions = server_response.details.data.transactions;

        dispatch({
            type: "statement",
            payload: {
                transactions: refresh
                    ? newTransactions
                    : state.statement?.transactions
                    ? [...state.statement.transactions, ...newTransactions]
                    : newTransactions,
                summary: server_response.details.data.summary,
            },
        });

        dispatch({ type: "metaData", payload: server_response.details.meta });
    } else {
        dispatch({ type: "statement", payload: "404" });
        dispatch({ type: "metaData", payload: "404" });
    }
};

  

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }


  return(
    <AccountReportContext.Provider value={{
      ...state, 
      dispatch,
      getStatement,
      setCurrentPage 
      }}>
      {children}
    </AccountReportContext.Provider>
  )

}

export const useAccountReport = ()=>useContext(AccountReportContext);

